import React from 'react';

const Footer = () => (
  <footer className="container mx-auto mt-48 mb-8 text-gray-800">
    <div className="flex  flex-wrap px-1">
      <div className="flex-1 p-3">
        <h2 className="text-lg font-semibold">About Us</h2>
        <p className="mt-5">PunchIn&reg; is a trading name owned by 2VM Consulting Limited, London &copy;2021</p>
      </div>
      <div className="flex-1 p-3">
        <h2 className="text-lg font-semibold">Important Links</h2>
        <ul className="mt-4 leading-loose">
          <li>
            <a href="/termsandconditions">Terms &amp; Conditions</a>
          </li>
          <li>
            <a href="/privacy">Privacy Policy</a>
          </li>
        </ul>
      </div>
      <div className="flex-1 p-3">
        <h2 className="text-lg font-semibold">Social Media</h2>
        <ul className="mt-4 leading-loose">
          <li>
            <a href="https://www.linkedin.com/company/punch-in-uk">LinkedIn</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
);

export default Footer;
